document.addEventListener('DOMContentLoaded', function () {
  function initBars() {
    const galleryViewer = document.querySelector('[id^="GalleryViewer-"]');
    const thumbnailItems = document.querySelectorAll('.thumbnail-list__item');

    if (!galleryViewer || thumbnailItems.length === 0) return;

    const existing = document.querySelector('.kambukka-bars');
    if (existing) existing.remove();

    let currentIndex = 0;

    // Bars aanmaken
    const barList = document.createElement('ul');
    barList.classList.add('kambukka-bars');

    thumbnailItems.forEach(function (item, index) {
      const li = document.createElement('li');
      const btn = document.createElement('button');
      btn.classList.add('kambukka-bars__bar');
      btn.style.transition = 'width 0.7s cubic-bezier(0.34, 1.8, 0.64, 1), opacity 0.4s ease';
      btn.style.width = index === 0 ? '24px' : '10px';
      btn.style.opacity = index === 0 ? '1' : '0.25';
      btn.setAttribute('aria-label', 'Ga naar afbeelding ' + (index + 1));

      btn.addEventListener('click', function () {
        goTo(index);
      });

      li.appendChild(btn);
      barList.appendChild(li);
    });

    galleryViewer.parentNode.insertBefore(barList, galleryViewer.nextSibling);

    // Navigeer naar specifieke index via thumbnail klik
    function goTo(index) {
      const total = thumbnailItems.length;
      if (index < 0 || index >= total) return;
      currentIndex = index;
      const thumbnailBtn = thumbnailItems[index].querySelector('button.thumbnail');
      if (thumbnailBtn) thumbnailBtn.click();
      updateBars();
    }

    // Bars updaten
    function updateBars() {
      const bars = document.querySelectorAll('.kambukka-bars__bar');
      bars.forEach(function (bar, i) {
        bar.style.width = i === currentIndex ? '24px' : '10px';
        bar.style.opacity = i === currentIndex ? '1' : '0.25';
      });
    }

    // Observer voor wanneer Dawn zelf de actieve thumbnail wijzigt
    const observer = new MutationObserver(function () {
      thumbnailItems.forEach(function (item, index) {
        const btn = item.querySelector('button.thumbnail');
        if (btn && btn.getAttribute('aria-current') === 'true') {
          currentIndex = index;
          updateBars();
        }
      });
    });

    thumbnailItems.forEach(function (item) {
      const btn = item.querySelector('button.thumbnail');
      if (btn) {
        observer.observe(btn, {
          attributes: true,
          attributeFilter: ['aria-current']
        });
      }
    });

    // Swipe detectie — max 1 image per swipe
    let touchStartX = 0;
    let touchStartY = 0;
    let isSwiping = false;

    galleryViewer.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isSwiping = false;
    }, { passive: true });

    galleryViewer.addEventListener('touchmove', function (e) {
      if (isSwiping) {
        e.preventDefault();
      }
      const diffX = Math.abs(e.touches[0].clientX - touchStartX);
      const diffY = Math.abs(e.touches[0].clientY - touchStartY);
      if (diffX > diffY && diffX > 10) {
        isSwiping = true;
        e.preventDefault();
      }
    }, { passive: false });

    galleryViewer.addEventListener('touchend', function (e) {
      if (!isSwiping) return;
      const diffX = e.changedTouches[0].clientX - touchStartX;
      const threshold = 50;

      if (diffX < -threshold) {
        goTo(currentIndex + 1);
      } else if (diffX > threshold) {
        goTo(currentIndex - 1);
      }

      isSwiping = false;
    }, { passive: true });
  }

  initBars();
});